import React from 'react'
import Navbar from '../components/Navbar'
import bg1 from '../assets/bg-onas.jpg'
import Footer from '../components/Footer'
import {Items, eksperci} from '../components/OnasItems'

function Onas() {
  return (
    <div>
      <Navbar />

      <div className='pt-20 flex justify-center mx-auto static'>
          <div className='bg-white bg-opacity-90 absolute mx-auto justify-center mt-12 max-w-[450px] text-center py-8 rounded-xl px-2'>
            <h3 className='uppercase text-xl md:text-3xl font-semibold pb-2'>O Firmie</h3>
            <p className='font-normal'>Firma Oniko-Expert Sp. z o.o. to przedsiębiorstwo konsultingowe, które w ramach swoich usług zajmuje się doradztwem w zakresie finansów i prawa. Wieloletnie doświadczenie na rynku zdobyte przez naszych pracowników i współpracowników pozwoliło nam stworzyć firmę przyjazną każdemu Klientowi, firmę, którą wyróżnia precyzja, dokładność oraz dbałość o relację z Klientem.</p>
          </div>
        <img src={bg1} alt="background photo" className='w-screen h-96 object-cover'/>
      </div>  

      <div className='max-w-[1240px] bg-white mx-auto justify-center text-center'>
        <div className='grid md:grid-cols-3 grid-cols-1 gap-3 pt-10 px-10'>
          {Items.map((item) => (
            <div key={item.id} className='px-12 pt-2 bg-slate-50 rounded-xl hover:bg-slate-100 duration-500'>
              <h2 className='font-semibold pb-2 text-xl md:text-2xl'>{item.title}</h2>
              <p className='pb-2'>{item.text}</p>
            </div>
          ))}
        </div>
        
        <div className='grid md:grid-cols-2 grid-cols-1 gap-5 place-items-center pt-20'>
            {eksperci.map((item) => (
              <div key={item.id} className='px-20 pt-10'>
                <div className='bg-[#040dc4] w-40 h-40 rounded-full flex mx-auto'>
                    <img src={item.img} className='object-cover h-40 w-40 rounded-full'/>
                </div> 
                <h3 className='text-xl md:text-2xl font-bold'>{item.name}</h3>
                <h4 className='text-md md:text-xl font-normal pb-2'>{item.prof}</h4>
                <p>{item.text}</p>
              </div>
            ))}
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default Onas